import React, { useState } from "react";

import { Link } from 'react-router-dom';
import { Timeline, TimelineItem, TimelineSeparator, TimelineConnector, TimelineDot, TimelineContent } from '@mui/lab';
import { FaCheckCircle, FaStar, FaThumbsUp, FaInfoCircle } from 'react-icons/fa';
import { Grid, Paper, Typography, Button, Container } from '@mui/material';
import { Stack } from '@mui/material';
import { timelineItemClasses } from '@mui/lab/TimelineItem';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import RecordVoiceOverIcon from '@mui/icons-material/RecordVoiceOver';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import BalanceIcon from '@mui/icons-material/Balance';
import TaskIcon from '@mui/icons-material/Task';
import AccordionItem from "../../accordion/accordion-item";
import '../../../css/statut-juridique.css';
import CustomButton from "../../../layouts/CustomButton";




const companyData = [
  { id: 1, name: 'SAS / SASU', description: 'Description of SAS / SASU' },  
  { id: 2, name: 'SARL / EURL', description: 'Description of SARL / EURL' },
  { id: 3, name: 'SCI', description: 'Description of SCI' },
  { id: 4, name: 'Micro-Entreprise (Auto-entrepreneur)', description: 'Description of Micro-Entreprise' },
  { id: 5, name: 'Association', description: 'Description of Association' },
];

function PositionedTimeline() {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
 
 
 
  return (
    <>
      <Timeline
  sx={{
    maxWidth: "800px", 
    margin: "0 auto", 
    [`& .${timelineItemClasses.root}:before`]: isSmallScreen
      ? {
          flex: 0,
          padding: 0,
        }
      : undefined,
  }}
  position={isSmallScreen ? undefined : "alternate-reverse"}
>
        <TimelineItem sx={{ alignItems: "center" }}>
          <TimelineSeparator>
            <TimelineConnector
              sx={{ height: "50px", background: "transparent" }}
            />
            <TimelineDot
              sx={{
                backgroundColor: "rgb(162, 221, 199)",
                borderColor: "white",
                borderWidth: 5,
                borderStyle: "solid",
                width: 45,
                height: 45,
                margin: 0,
              }}
            />
            <TimelineConnector sx={{ height: "50px" }} />
          </TimelineSeparator>
          <TimelineContent>
            <Paper elevation={3} sx={{ padding: 1 }}>
              <Stack spacing={2} direction="row" alignItems={"center"}>
                <ReceiptLongIcon
                  sx={{ color: "rgb(162, 221, 199)", fontSize: "40px" }}
                />
                <Typography align="right" style={{ fontSize:'font-size: 1rem !important' }}>
                Étape 1              
                 </Typography>
              </Stack>
            </Paper>
          </TimelineContent>
        </TimelineItem>
        <TimelineItem sx={{ alignItems: "center" }}>
          <TimelineSeparator>
            <TimelineConnector sx={{ height: "50px" }} />
            <TimelineDot
              sx={{
                backgroundColor: "rgb(162, 221, 199)",
                borderColor: "white",
                borderWidth: 5,
                borderStyle: "solid",
                width: 45,
                height: 45,
                margin: 0,
              }}
            />
            <TimelineConnector sx={{ height: "50px" }} />
          </TimelineSeparator>
          <TimelineContent>
            <Paper elevation={3} sx={{ padding: 1 }}>
              <Stack spacing={2} direction="row" alignItems={"center"}>
                <RecordVoiceOverIcon
                  sx={{ color: "rgb(162, 221, 199)", fontSize: "40px" }}
                />
                <Typography align="left">
                Étape 2
                </Typography>
              </Stack>
            </Paper>
          </TimelineContent>
        </TimelineItem>
        <TimelineItem sx={{ alignItems: "center" }}>
          <TimelineSeparator>
            <TimelineConnector sx={{ height: "50px" }} />
            <TimelineDot
              sx={{
                backgroundColor: "rgb(162, 221, 199)",
                borderColor: "white",
                borderWidth: 5,
                borderStyle: "solid",
                width: 45,
                height: 45,
                margin: 0,
              }}
            />
            <TimelineConnector sx={{ height: "50px" }} />
          </TimelineSeparator>
          <TimelineContent>
            <Paper elevation={3} sx={{ padding: 1 }}>
              <Stack spacing={2} direction="row" alignItems={"center"}>
                <AccountBalanceIcon
                  sx={{ color: "rgb(162, 221, 199)", fontSize: "40px" }}
                />
                <Typography align="left">
                Étape 4
                </Typography>
              </Stack>
            </Paper>
          </TimelineContent>
        </TimelineItem>
        <TimelineItem sx={{ alignItems: "center" }}>
          <TimelineSeparator>
            <TimelineConnector sx={{ height: "50px" }} />
            <TimelineDot
              sx={{
                backgroundColor: "rgb(162, 221, 199)",
                borderColor: "white",
                borderWidth: 5,
                borderStyle: "solid",
                width: 45,
                height: 45,
                margin: 0,
              }}
            />
            <TimelineConnector sx={{ height: "50px" }} />
          </TimelineSeparator>
          <TimelineContent>
            <Paper elevation={3} sx={{ padding: 1 }}>
              <Stack spacing={2} direction="row" alignItems={"center"}>
                <BalanceIcon
                  sx={{ color: "rgb(162, 221, 199)", fontSize: "40px" }}
                />
                <Typography align="left">
                   Étape 4
                </Typography>
              </Stack>
            </Paper>
          </TimelineContent>
        </TimelineItem>
        <TimelineItem sx={{ alignItems: "center" }}>
          <TimelineSeparator>
            <TimelineConnector sx={{ height: "50px" }} />
            <TimelineDot
              sx={{
                backgroundColor: "rgb(162, 221, 199)",
                borderColor: "white",
                borderWidth: 5,
                borderStyle: "solid",
                width: 45,
                height: 45,
                margin: 0,
              }}
            />
            <TimelineConnector
              sx={{ height: "50px", background: "transparent" }}
            />
          </TimelineSeparator>
          <TimelineContent>
            <Paper elevation={3} sx={{ padding: 1 }}>
              <Stack spacing={2} direction="row" alignItems={"center"}>
                <TaskIcon
                  sx={{ color: "rgb(162, 221, 199)", fontSize: "40px" }}
                />
                <Typography align="left">Étape 5</Typography>
              </Stack>
            </Paper>
          </TimelineContent>
        </TimelineItem>
      </Timeline>
    </>
  );
}



const CompanyCard = ({ item }) => {
 
  
  return (
    <Paper
      elevation={6}
      style={{
        padding: '10px',
        boxShadow: '0px 6px 6px -3px rgba(0, 0, 0, 0.2), 0px 10px 14px 1px rgba(0, 0, 0, 0.14), 0px 4px 18px 3px rgba(0, 0, 0, 0.12)',
        borderRadius: '5px',
        border: '2px solid rgb(25, 175, 120)',
        textAlign: 'center',
        transition: 'transform 0.3s, box-shadow 0.3s',
      }}
      className="card_solution"
    >
    
    <div style={{ marginBottom: '20px' }}>
        <FaInfoCircle size={50} style={{ color: '#007bff' }} />
      </div>
      <Typography variant="h6" gutterBottom style={{ fontWeight: 'bold' }}>
        {item.name}
      </Typography>
      <Typography variant="body2" color="textSecondary" paragraph>
        {item.description}
      </Typography>
      <div style={{ display: 'flex', justifyContent: 'center', gap: '10px' }}>
        <Link to="/en-savoir-plus">
          <Button variant="contained" color="primary" sx={{textTransform:"none"}} >
            En savoir plus
          </Button>
        </Link>   
        <CustomButton to="/create_soc">
                    Créer
              </CustomButton >                    
        
        
      </div>
    </Paper>
  );
};




const StatutJuridiqueArea = ({ style_2 = false }) => {
  const [openItems, setOpenItems] = useState([]); 
  
  const toggleItem = (id) => {
    setOpenItems((prevOpenItems) =>
      prevOpenItems.includes(id)
        ? prevOpenItems.filter((item) => item !== id) 
        : [...prevOpenItems, id] 
    );
  };

  const cardStyle = {
    width: '100%',
    padding: '10px',
    boxShadow: '0px 6px 6px -3px rgba(0, 0, 0, 0.2), 0px 10px 14px 1px rgba(0, 0, 0, 0.14), 0px 4px 18px 3px rgba(0, 0, 0, 0.12)',
    borderRadius: '5px',
    border: '2px solid rgb(25, 175, 120)',
    textAlign: 'center',
    transition: 'transform 0.3s, box-shadow 0.3s',
  };

  const rowStyle = {
    padding: '40px',
  };

  return (
    <div className="hero-banner-two position-relative background_section">
      <div className="container">
        <div className="position-relative pb-80 lg-pb-10" style={{ paddingTop: '169px', paddingBottom: '5px' }}
>
          <div className="row">
            <div className="col-lg-12 col-md-12">
              <h2 className="text-center fw-600">Titre</h2>
              <p className="text-md mt-35 mb-50 lg-mb-30  text-center">
                Le statut juridique utilisé pour la création d'une entreprise désigne la forme légale sous laquelle une entreprise est constituée, déterminant ainsi ses obligations fiscales, sociales et légales, ainsi que la responsabilité de ses associés ou dirigeants.
              </p>
            </div>
          </div>
        </div>
      </div>

      <section className="blog-section-two pt-20 xl-pt-0lg-pt-0 pb-5" style={{ backgroundColor: '#FFF' }}>        
          <div className="row">
            <div className="col-12">
              <div className="wrapper">
              <div className="pt-2">
                <Container>
                  <Typography variant="h2" align="center" gutterBottom style={{ marginBottom: '40px' }}>
                    <h2 className="title_staut fw-600">Choisissez le statut juridique de votre future entreprise</h2>
                  </Typography>
                  <Grid container spacing={3} justifyContent="center" className="row gx-xxl-5">
                    {companyData.map((item) => (
                      <Grid
                        key={item.id}
                        item
                        xs={12}
                        sm={6}
                        md={4}
                        className="col-lg-4 col-md-6 mt-4"
                      >
                        <CompanyCard item={item} />
                      </Grid>
                    ))}
                  </Grid>
                </Container>
              </div>

                <br />
                <br />
                <div className="blog-section-two px-4 pt-20 pb-20 background_section">
                  <div className="title-one text-center mb-20 lg-mb-10 ">
                    <h3 className="title_staut fw-600 font-500">
                      Vous ne savez pas quel statut choisir ou estimez vos futures charges,
                      utilisez notre simulateur ou prenez rendez-vous avec nos experts
                    </h3>
                  </div>      
                  <div className="row justify-content-center" style={rowStyle}>
                    <div className="col-md-6 col-lg-4 d-flex mb-4">
                      <div className="card" style={cardStyle}>
                        <img
                          src="/assets/images/blog/entreprise.jpg"
                          className="card-img-top"  
                          style={{ height: '200px', objectFit: 'cover' }}
                        />
                        <div className="card-body text-center">
                          <h5 className="card-title fw-600">Choisir votre forme juridique</h5>
                          <p className="card-text">texte</p>
                          <CustomButton to="/activite-statut" style={{width:"50%"}}>
                            Lancer le simulateur
                          </CustomButton >  
                        
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6 col-lg-4 d-flex mb-4">
                      <div className="card  mx-auto" style={cardStyle}>
                        <img
                          src="/assets/images/blog/entreprise.jpg"
                          className="card-img-top"
                          alt="Image 2"
                          style={{ height: '200px', objectFit: 'cover' }}
                        />
                        <div className="card-body text-center">
                          <h5 className="card-title fw-600">Echanger avec un expert</h5>
                          <p className="card-text">texte (prix)</p>
                          <CustomButton to="/rendez-vous1" style={{width:"50%"}}>
                            Lancer le simulateur
                          </CustomButton > 
                         
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6 col-lg-4 d-flex mb-4">
                      <div className="card mx-auto" style={cardStyle}>
                        <img
                          src="/assets/images/blog/entreprise.jpg"
                          className="card-img-top"
                          alt="Image 3"
                          style={{ height: '200px', objectFit: 'cover' }}
                        />
                        <div className="card-body text-center">
                          <h5 className="card-title fw-600">Estimer vos charges</h5>
                          <p className="card-text">texte</p>
                          <CustomButton to="/statut-juridique-simulateur" style={{width:"50%"}}>
                            Lancer le simulateur
                          </CustomButton > 
                        
                         
                        </div>
                      </div>
                    </div>
                  </div>
                </div>



                <div className="title-one text-center  mt-4">
                  <h2 className="fw-600">Les étapes de création d’une entreprise</h2>
                </div>
                <PositionedTimeline />
            <section className="text-feature-three position-relative background_section mb-4" /* pt-225 xl-pt-200 lg-pt-150 md-pt-100 */>
                  <div className="container">
                    <div className="row">
                      <div className="col-lg-12 order-lg-last ms-auto">
                          <div className="title-two">                        
                              <h2 className="fw-600 color-blue text-center">Questions fréquentes</h2>
                          </div>
                          <div className="accordion accordion-style-one color-two mt-40" id="accordionOne">
                            <AccordionItem
                              id="one"
                              isShow={openItems.includes("one")}
                              toggleItem={() => toggleItem("one")}
                              title="Question 1 ?"
                              desc="Texte réponse"
                            />
                            <AccordionItem
                              id="two"
                              isShow={openItems.includes("two")}
                              toggleItem={() => toggleItem("two")}
                              title="Question 2 ?"
                              desc="Texte réponse"
                            />
                            <AccordionItem
                              id="three"
                              isShow={openItems.includes("three")}
                              toggleItem={() => toggleItem("three")}
                              title="Question 3 ?"
                              desc="Texte réponse"
                            />
                          </div>
                        
                      </div>                
                    </div>
                  </div>
                </section>

                <div className="title-one text-center mb-50 ">
                  <h2 className="fw-600 mb-4">Pourquoi nous choisir ?</h2>
                  <div className="container">
                    <div className="row">
                      <div className="col-md-4">
                        <div className="feature-item text-center p-4 border rounded shadow-sm">
                          <FaStar size={40} className="text-warning mb-3" />
                          <h5 className="fw-600">Argument 1</h5>
                          <p>text</p>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="feature-item text-center p-4 border rounded shadow-sm">
                          <FaThumbsUp size={40} className="text-warning mb-3" />
                          <h5 className="fw-600">Argument 2</h5>
                          <p>text</p>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="feature-item text-center p-4 border rounded shadow-sm">
                          <FaCheckCircle size={40} className="text-warning mb-3" />
                          <h5 className="fw-600">Argument 3</h5>
                          <p>text</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="title-one text-center  mb-1 lg-mb-2

 ">
                  <h2 className="fw-600">Nos tarifs</h2>
                </div>

                <div className="table-responsive mb-50 px-4">
                  <table className="table table-striped table-bordered">
                    <thead>
                      <tr>
                        <th>Formalités</th>
                        <th>Nos Tarifs</th>
                        <th>Concurrents en ligne</th>
                        <th>Avocats</th>
                        <th>Experts-comptables</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>formalité 1</td>
                        <td>texte + prix</td>
                        <td>texte + prix</td>
                        <td>texte + prix</td>
                        <td>texte + prix</td>
                      </tr>
                      <tr>
                        <td>formalité 2</td>
                        <td>texte + prix</td>
                        <td>texte + prix</td>
                        <td>texte + prix</td>
                        <td>texte + prix</td>
                      </tr>
                      <tr>
                        <td>formalité 3</td>
                        <td>texte + prix</td>
                        <td>texte + prix</td>
                        <td>texte + prix</td>
                        <td>texte + prix</td>
                      </tr>
                      <tr>
                        <td>formalité 4</td>
                        <td>texte + prix</td>
                        <td>texte + prix</td>
                        <td>texte + prix</td>
                        <td>texte + prix</td>
                      </tr>
                      <tr>
                        <td>formalité 5</td>
                        <td>texte + prix</td>
                        <td>texte + prix</td>
                        <td>texte + prix</td>
                        <td>texte + prix</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

              </div>
            </div>
          </div>        
      </section>
    </div>
    
  );
};

export default StatutJuridiqueArea;
